import { objectKeys } from '@coxy/utils'
import type { Store } from '@reduxjs/toolkit'
import type { AppState } from '@shared-core/store'
import { APP_STORAGE_STORE } from '@web/store/common'
import { storageState } from '@web/store/storages/store'

export const restoreStore = (): AppState => {
  try {
    return JSON.parse(storageState.getString(APP_STORAGE_STORE) || '{}')
  } catch (ignore) {
    console.error('restoreStore', ignore)
    return {} as AppState
  }
}

type WhitelistState = {
  [k: string]: string[]
}

function persistWhitelistedState(state: AppState, whitelist: WhitelistState): void {
  const newState: Record<string, Record<string, unknown>> = {}

  objectKeys(state).forEach((storeKey) => {
    const sliceKey = storeKey as string
    newState[sliceKey] = { ...(state[storeKey] as Record<string, unknown>) }

    objectKeys(newState[sliceKey]).forEach((storeItem) => {
      if (!whitelist[sliceKey]?.includes(storeItem as string)) {
        delete newState[sliceKey][storeItem]
      }
    })
  })

  const newStateForSave = JSON.stringify(newState)

  if (newStateForSave !== storageState.getString(APP_STORAGE_STORE)) {
    storageState.set(APP_STORAGE_STORE, newStateForSave)
  }
}

// Сохраняет whitelist-поля стора в localStorage при каждом изменении.
export function watcher(store: Store, whitelist: WhitelistState): void {
  store.subscribe(() => {
    persistWhitelistedState(store.getState() as AppState, whitelist)
  })
}
